import { FormatColorMarkerCancelIcon } from './FormatColorMarkerCancelIcon';

/**
 * author: Michael Irigoyen
 * id C6D32152-B2F3-43D3-A78E-D69CBDC5E054
 * name format-color-marker-cancel
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-color-marker-cancel.svg
 * tags
 * - Text / Content / Format 
 * - Color 
 */
export const FormatColorRedactIcon = FormatColorMarkerCancelIcon;
export default FormatColorRedactIcon